import { useTheme } from 'vuetify'
import { ref, computed } from 'vue'

export const STORAGE_KEY = 'bbitbbit_theme'

export function getStoredThemeMode() {
    if (typeof window === 'undefined') return 'system'
    return localStorage.getItem(STORAGE_KEY) || 'system'
}

export function systemPrefersDark() {
    return typeof window !== 'undefined' &&
        window.matchMedia('(prefers-color-scheme: dark)').matches
}

/** 'light' | 'dark' | 'system' → Vuetify 테마 이름 */
export function resolveThemeName(mode) {
    if (mode === 'dark') return 'dark'
    if (mode === 'light') return 'light'
    return systemPrefersDark() ? 'dark' : 'light'
}

// 컴포넌트 간에 공유되는 반응형 상태
const _currentMode = ref(getStoredThemeMode())

let systemListenerAttached = false

function attachSystemListener(applyTheme) {
    if (systemListenerAttached || typeof window === 'undefined') return
    systemListenerAttached = true
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
        if (_currentMode.value === 'system') applyTheme()
    })
}

/**
 * 화면 모드 관리 컴포저블
 * 'light' | 'dark' | 'system'
 */
export function useThemeMode() {
    const theme = useTheme()

    const isDark = computed(() => theme.global.name.value === 'dark')
    const currentMode = computed(() => _currentMode.value)

    /** 저장된 설정을 읽어 Vuetify 테마에 적용 */
    const applyTheme = () => {
        theme.global.name.value = resolveThemeName(_currentMode.value)
    }

    attachSystemListener(applyTheme)

    /** 모드 변경 + 저장 + 즉시 적용 */
    const setMode = (mode) => {
        _currentMode.value = mode
        localStorage.setItem(STORAGE_KEY, mode)
        applyTheme()
    }

    return { isDark, currentMode, applyTheme, setMode }
}
